import { Button, Space } from 'antd'
import {
  DeleteOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
  InboxOutlined,
  SendOutlined,
} from '@ant-design/icons'
import { useTranslation } from 'react-i18next'

interface ProductEditHeaderButtonsProps {
  status: string
  isHidden: boolean
  onPublish: () => void
  onArchive: () => void
  onHide: () => void
  onUnhide: () => void
  onDelete: () => void
  onCancel: () => void
  onSave: () => void
  isPublishing: boolean
  isArchiving: boolean
  isHiding: boolean
  isUnhiding: boolean
  isDeleting: boolean
  isSaving: boolean
}

export function ProductEditHeaderButtons({
  status,
  isHidden,
  onPublish,
  onArchive,
  onHide,
  onUnhide,
  onDelete,
  onCancel,
  onSave,
  isPublishing,
  isArchiving,
  isHiding,
  isUnhiding,
  isDeleting,
  isSaving,
}: ProductEditHeaderButtonsProps) {
  const { t } = useTranslation()

  return (
    <Space>
      {isHidden ? (
        <Button
          data-testid="product-edit-unhide-btn"
          icon={<EyeOutlined />}
          loading={isUnhiding}
          onClick={onUnhide}
        >
          {t('common.buttons.unhide')}
        </Button>
      ) : (
        <Button
          data-testid="product-edit-hide-btn"
          icon={<EyeInvisibleOutlined />}
          loading={isHiding}
          onClick={onHide}
        >
          {t('common.buttons.hide')}
        </Button>
      )}
      {status === 'DRAFT' && (
        <Button
          data-testid="product-edit-publish-btn"
          icon={<SendOutlined />}
          loading={isPublishing}
          onClick={onPublish}
        >
          {t('common.buttons.publish')}
        </Button>
      )}
      {status === 'PUBLISHED' && (
        <Button
          data-testid="product-edit-archive-btn"
          icon={<InboxOutlined />}
          loading={isArchiving}
          onClick={onArchive}
        >
          {t('common.buttons.archive')}
        </Button>
      )}
      <Button
        data-testid="product-edit-delete-btn"
        danger
        icon={<DeleteOutlined />}
        loading={isDeleting}
        onClick={onDelete}
      >
        {t('common.buttons.delete')}
      </Button>
      <Button data-testid="product-edit-cancel-btn" onClick={onCancel}>
        {t('common.buttons.cancel')}
      </Button>
      <Button
        data-testid="product-edit-save-btn"
        type="primary"
        onClick={onSave}
        loading={isSaving}
      >
        {t('common.buttons.save')}
      </Button>
    </Space>
  )
}
